import React from "react";

export interface ImgSet {
  avif1200: string;
  avif600: string;
  webp1200: string;
  webp600: string;
  fallback: string;
}

interface PictureProps {
  src: ImgSet;
  alt: string;
  width: number;
  height: number;
  sizes?: string;
  priority?: "high" | "low" | "auto";
  lazy?: boolean;
  className?: string;
  style?: React.CSSProperties;
  srcWidths?: [number, number];
  responsiveVariantByViewport?: boolean;
}

const Picture: React.FC<PictureProps> = ({
  src,
  alt,
  width,
  height,
  sizes = "(max-width: 768px) 100vw, 1200px",
  priority = "auto",
  lazy = true,
  className,
  style,
  srcWidths,
  responsiveVariantByViewport = false,
}) => {
  const [sw, lw] = srcWidths ?? [600, 1200];
  return (
    <picture>
      {src.avif600 && src.avif1200 && (
        responsiveVariantByViewport ? (
          <>
            <source type="image/avif" media="(max-width: 768px)" srcSet={src.avif600} />
            <source type="image/avif" srcSet={src.avif1200} />
          </>
        ) : (
          <source
            type="image/avif"
            srcSet={`${src.avif600} ${sw}w, ${src.avif1200} ${lw}w`}
            sizes={sizes}
          />
        )
      )}
      {src.webp600 && src.webp1200 && (
        responsiveVariantByViewport ? (
          <>
            <source type="image/webp" media="(max-width: 768px)" srcSet={src.webp600} />
            <source type="image/webp" srcSet={src.webp1200} />
          </>
        ) : (
          <source
            type="image/webp"
            srcSet={`${src.webp600} ${sw}w, ${src.webp1200} ${lw}w`}
            sizes={sizes}
          />
        )
      )}
      <img
        src={src.fallback}
        alt={alt}
        width={width}
        height={height}
        loading={lazy ? "lazy" : "eager"}
        decoding={lazy ? "async" : "sync"}
        fetchPriority={priority}
        className={className}
        style={style}
      />
    </picture>
  );
};

export default Picture;
